import { useState } from "react";
import { useNavigate } from "react-router-dom";

import useInput from "../../hooks/useInput";
import baseUrl from "../../url/baseUrl";
import "./Auth_form.css";

// component tính năng quên mật khẩu
const ForgotPassword = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [formError, setFormError] = useState(false);

  const {
    data: email,
    setData: setEmail,
    error: emailError,
  } = useInput((input) => input.length > 0 && input.includes("@"));

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (email === "") {
      setFormError(true);
    } else if (!emailError) {
      setFormError(false);
      const url = baseUrl + "/forgot-password";

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "same-origin",
          mode: "cors",

          body: JSON.stringify({
            email: e.target.elements.email.value,
          }),
        });
        console.log(response.status);

        if (response.status === 404 || response.status === 422) {
          throw new Error(
            "Vui lòng điền đúng email và đảm bảo user này không bị khóa"
          );
        }

        if (response.status !== 201) {
          throw new Error("Có lỗi xảy ra với server!");
        }
        setMessage(null);
        const data = await response.json();

        alert(data.message);

        navigate("/login");
      } catch (err) {
        setMessage(err.message);
      }
    }
  };

  return (
    <div className="form_control_wrap">
      <div className="form__wrap">
        <form className="form-control" onSubmit={handleResetPassword}>
          <h1 className="text-success">Forgot password?</h1>
          {formError && <p className="error_auth">Vui lòng điền email.</p>}

          {emailError && <p className="error_auth">Email không hợp lệ!</p>}

          {message && <p className="error_auth">{message}</p>}
          <div>
            <div className="form_email">
              <input
                name="email"
                value={email}
                type="email"
                placeholder="Email của bạn"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>
          <div>
            <button
              className="btn btn-success w-25"
              style={{ height: "50px" }}
              type="submit"
            >
              RESET
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
